import { GridRowId } from "@mui/x-data-grid";
import {
  SET_SELECTED_CLAIM_TYPE,
  SET_SELECTED_CLAIM_SUB_TYPE,
  SET_IN_CLAIM_SUMMARY_PAGE,
  SET_MONTH,
  SET_SEARCH_TEXT,
  SET_CHECKED_CLAIM_IDS,
  SET_CLAIM_IDS_CHECKBOX_HIDDEN,
  SET_OPEN,
  SET_SELECTED_ROW_TO_EDIT,
  SET_CLAIM_SUMMARY_ROWS,
  SET_DISABLE_EDITING,
  SET_ADD_RETURN_MODAL_VISIBLE,
  SET_RETURN_PRODUCTS_ARRAY,
  SET_RETURN_PRODUCT_OBJECT,
  SET_BATCH_IDS_EXPANDED,
  SET_CHECKED_BATCHES,
  SET_APPROVAL_MODAL_OPEN,
  SET_APPROVAL_MODAL_STATE,
  SET_SELECTED_RETURN_PRODUCT_ARRAY_IDX,
  SET_RETURN_PRODUCT_OBJECT_INITIAL,
  SET_RETURN_PRODUCT_OBJECT_ORIGINAL,
  SET_SALE_RETURNS_ROWS,
  SET_INITIAL_SALE_RETURNS_ROWS,
  SET_INITIAL_SECONDARY_SCHEMES_ROW,
  SET_SECONDARY_SCHEMES_ROW,
  SET_SELECTED_SECONDARY_SCHEMES_ROW,
  SET_SELECTED_INVOICE_ROW,
  RESET_CLAIMS_STATE,
  SET_DISCOUNT_MODAL_STATE ,
  SET_SECONDARY_SCHEMES_CHECKED_CLAIM_IDS,
  SET_TOTAL_ORDER_VALUE_ROW,
  SET_SELECTED_TOTAL_ORDER_VALUE_ROW,
  SET_TOTAL_ORDER_VALUE_CHECKED_CLAIM_IDS,
  SET_EDITED_BATCHES,
  SET_OPEN_CLAIMS_ROWS,
  SET_SELECTED_OPEN_CLAIMS_ROW,
  SET_VIEW_CLAIMS_ROWS,
  SET_SELECTED_VIEW_CLAIMS_ROW,
  SET_NON_ELIGIBLE
} from "../types/claimTypes";

interface State {
  selectedClaimType: string;
  selectedClaimSubType: string;
  inClaimSummaryPage: boolean;
  month: string;
  searchText: string;
  claimSummmaryRows: any[];

  saleReturnsCheckedClaimIds: GridRowId[];
  saleReturnsClaimIdsCheckboxHidden: GridRowId[];
  open: boolean;
  selectedRowToEdit: any | null;
  disableEditing: boolean;

  addReturnModalVisible: boolean;
  returnProductsArray: any[];
  returnProductObject: object;
  batchIdsExpanded: boolean;
  checkedBatches: any[];
  editedBatches: any[];
  inInvoiceDetailsPage: boolean;

  approvalModalOpen: boolean;
  approvalModalState: number;
  selectedReturnProductArrayIdx: any | null;
  returnProductObjectInitial: any;
  returnProductObjectOriginal: any[];
  viewOnly: boolean;
  saleReturnsRows: any[];
  initialSaleReturnsRows: any[];
  initialSecondarySchemesRows: any[];
  secondarySchemesRows: any[];
  selectedSecondarySchemeRow: {};
  selectedInvoiceRow: {};
  totalOrderValueRows: any[];
  openClaimsRows:any[];
  selectedOpenClaimsRow: {};
  viewClaimsRows:any[];
  selectedViewClaimsRow: {};
  selectedTotalOrderValueRow: {};
  discountModalState:boolean
  secondarySchemesCheckedClaimIds:any[];
  totalOrderValueCheckedClaimIds:any[]
  nonEligible: any[];
}

const initialState: State = {
  selectedClaimType: "",
  selectedClaimSubType: "",
  inClaimSummaryPage: false,
  month: "",
  searchText: "",
  claimSummmaryRows: [],
  saleReturnsClaimIdsCheckboxHidden: [],
  saleReturnsCheckedClaimIds: [],
  open: false,
  selectedRowToEdit: null,
  disableEditing: false,

  addReturnModalVisible: false,
  returnProductsArray: [],
  returnProductObject: {},
  batchIdsExpanded: false,
  checkedBatches: [],
  editedBatches: [],
  inInvoiceDetailsPage: false,

  approvalModalOpen: false,
  approvalModalState: 1,
  selectedReturnProductArrayIdx: null,
  returnProductObjectInitial: undefined,
  returnProductObjectOriginal: [],
  viewOnly: false,
  saleReturnsRows: [],
  initialSaleReturnsRows: [],
  initialSecondarySchemesRows: [],
  secondarySchemesRows: [],
  selectedSecondarySchemeRow: {},
  selectedInvoiceRow: {},
  totalOrderValueRows: [],
  selectedTotalOrderValueRow: {},
  openClaimsRows: [],
  selectedOpenClaimsRow: {},
  viewClaimsRows: [],
  selectedViewClaimsRow: {},
  discountModalState:false,
  secondarySchemesCheckedClaimIds:[],
  totalOrderValueCheckedClaimIds:[],
  nonEligible: []
};

const claimsReducer = (state = initialState, action: any): State => {
  switch (action.type) {
    case SET_SECONDARY_SCHEMES_CHECKED_CLAIM_IDS:
      return { ...state, secondarySchemesCheckedClaimIds: action.payload };
    case SET_DISCOUNT_MODAL_STATE:
      return { ...state, discountModalState: action.payload };
    case RESET_CLAIMS_STATE:
      return initialState;
    case SET_OPEN_CLAIMS_ROWS:
      return { ...state, openClaimsRows: action.payload };
    case SET_SELECTED_OPEN_CLAIMS_ROW:
      return { ...state, selectedOpenClaimsRow: action.payload };
    case SET_VIEW_CLAIMS_ROWS:
      return { ...state, viewClaimsRows: action.payload };
    case SET_SELECTED_VIEW_CLAIMS_ROW:
      return { ...state, selectedViewClaimsRow: action.payload };
    case SET_SELECTED_SECONDARY_SCHEMES_ROW:
      return { ...state, selectedSecondarySchemeRow: action.payload };
    case SET_SELECTED_INVOICE_ROW:
      return { ...state, selectedInvoiceRow: action.payload };
    case SET_INITIAL_SECONDARY_SCHEMES_ROW:
      return { ...state, initialSecondarySchemesRows: action.payload };
    case SET_SECONDARY_SCHEMES_ROW:
      return { ...state, secondarySchemesRows: action.payload };
    case SET_TOTAL_ORDER_VALUE_ROW:
      return { ...state, totalOrderValueRows: action.payload };
    case SET_SELECTED_TOTAL_ORDER_VALUE_ROW:
      return { ...state, selectedTotalOrderValueRow: action.payload };
    case SET_TOTAL_ORDER_VALUE_CHECKED_CLAIM_IDS:
      return { ...state, totalOrderValueCheckedClaimIds: action.payload };
    case SET_SALE_RETURNS_ROWS:
      return { ...state, saleReturnsRows: action.payload };
    case SET_INITIAL_SALE_RETURNS_ROWS:
      return { ...state, initialSaleReturnsRows: action.payload };
    case SET_SELECTED_CLAIM_TYPE:
      return { ...state, selectedClaimType: action.payload };
    case SET_SELECTED_CLAIM_SUB_TYPE:
      return { ...state, selectedClaimSubType: action.payload };
    case SET_IN_CLAIM_SUMMARY_PAGE:
      return { ...state, inClaimSummaryPage: action.payload };
    case SET_MONTH:
      return { ...state, month: action.payload };
    case SET_SEARCH_TEXT:
      return { ...state, searchText: action.payload };
    case SET_CLAIM_SUMMARY_ROWS:
      return { ...state, claimSummmaryRows: action.payload };
    case SET_CHECKED_CLAIM_IDS:
      return { ...state, saleReturnsCheckedClaimIds: action.payload };
    case SET_CLAIM_IDS_CHECKBOX_HIDDEN:
      return { ...state, saleReturnsClaimIdsCheckboxHidden: action.payload };
    case SET_OPEN:
      return { ...state, open: action.payload };
    case SET_SELECTED_ROW_TO_EDIT:
      return { ...state, selectedRowToEdit: action.payload };
    case SET_DISABLE_EDITING:
      return { ...state, disableEditing: action.payload };
    case SET_ADD_RETURN_MODAL_VISIBLE:
      return { ...state, addReturnModalVisible: action.payload };
    case SET_RETURN_PRODUCTS_ARRAY:
      return { ...state, returnProductsArray: action.payload };
    case SET_RETURN_PRODUCT_OBJECT:
      return { ...state, returnProductObject: action.payload };
    case SET_BATCH_IDS_EXPANDED:
      return { ...state, batchIdsExpanded: action.payload };
    case SET_CHECKED_BATCHES:
      return { ...state, checkedBatches: action.payload };
    case SET_EDITED_BATCHES:
      return { ...state, editedBatches: action.payload };
    case SET_APPROVAL_MODAL_OPEN:
      return { ...state, approvalModalOpen: action.payload };
    case SET_APPROVAL_MODAL_STATE:
      return { ...state, approvalModalState: action.payload };
    case SET_SELECTED_RETURN_PRODUCT_ARRAY_IDX:
      return { ...state, selectedReturnProductArrayIdx: action.payload };
    case SET_RETURN_PRODUCT_OBJECT_INITIAL:
      return { ...state, returnProductObjectInitial: action.payload };
    case SET_RETURN_PRODUCT_OBJECT_ORIGINAL:
      return { ...state, returnProductObjectOriginal: action.payload };
    case SET_NON_ELIGIBLE:
      return { ...state, nonEligible: action.payload };
    default:
      return state;
  }
};

export default claimsReducer;
